import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";
import { delay } from "../../helper/delayresponse";

interface DuplicateNumbersReports {
    id?: number;
    number: string;
    campaign_names: string;
}

interface DuplicateNumbersReportsState {
    duplicatereportdata: DuplicateNumbersReports[];
    info: { count: number; current_page: number; limit: number; total_page: number } | null;
    error: string | null;
    loading: boolean;
}

// ====================-Duplicate-numbers-reports-action-start==============
export const GetallDuplicateNumbersReports = createAsyncThunk<
    { data: DuplicateNumbersReports[], info: { count: number; current_page: number; limit: number; total_page: number } },
    { search: string; page: number; limit: number },
    { rejectValue: string }
>(
    'duplicatereportdata',
    async ({ search, page, limit }, { rejectWithValue }) => {
        try {
            await delay(1000)
            const response = await axiosInstance.get(`api/admin/reports/duplicate-numbers-reports`, {
                params: { search, page, limit },
            });
            return { data: response.data.data, info: response.data.info };
        } catch (error: any) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message);
        }
    }
);
// ====================Duplicate-numbers-reports-action-start==============

const initialState: DuplicateNumbersReportsState = {
    duplicatereportdata: [],
    info: null,
    error: null,
    loading: false,
};

const duplicatenumbersreportsSlice = createSlice({
    name: "Duplicatenumbersreports",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // ===============get-all-duplicate-numbers-slice-start============
            .addCase(GetallDuplicateNumbersReports.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetallDuplicateNumbersReports.fulfilled, (state, action: PayloadAction<{ data: DuplicateNumbersReports[], info: { count: number; current_page: number; limit: number; total_page: number } }>) => {
                state.loading = false;
                state.duplicatereportdata = action.payload.data;
                state.info = action.payload.info;
            })
            .addCase(GetallDuplicateNumbersReports.rejected, (state, action: PayloadAction<string | undefined>) => {
                state.loading = false;
                state.error = action.payload || 'An error occurred';
            });
        // ===============get-all-duplicate-numbers-slice-end============

    },
});

export default duplicatenumbersreportsSlice.reducer;